// @flow

export const getDevicePlatform = (): string => 'SmartTV'
export const getDeviceType = (): string => 'TV'
